/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Maja.Server | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssignableAccessDto,
  CreateProfileDto,
  GetApiV1ProfileParams,
  GetApiV1ProfilesProfileParams,
  MailSettingsDto,
  PostApiV1ProfileIdParams,
  PostApiV1ProfilesProfileIdParams,
  ProblemDetails,
  Profile,
  ProfileDto,
  ProfilePermissionsDto,
  ReceptionDto,
  SetTenantRequest,
  UserProfileDetailsDto
} from '../model';

import { visitorApiInstance } from '../../axios-instance';




export const getApiV1ProfilesProfile = (
    params?: GetApiV1ProfilesProfileParams,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto[]>(
      {url: `/api/v1/profiles/Profile`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1ProfilesProfileQueryKey = (params?: GetApiV1ProfilesProfileParams,) => {
    return [
    `/api/v1/profiles/Profile`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1ProfilesProfileQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError = unknown>(params?: GetApiV1ProfilesProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfilesProfileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfilesProfile>>> = ({ signal }) => getApiV1ProfilesProfile(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfilesProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfilesProfile>>>
export type GetApiV1ProfilesProfileQueryError = unknown


export function useGetApiV1ProfilesProfile<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError = unknown>(
 params: undefined |  GetApiV1ProfilesProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfile>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfile<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError = unknown>(
 params?: GetApiV1ProfilesProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfile>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfile<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError = unknown>(
 params?: GetApiV1ProfilesProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfilesProfile<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError = unknown>(
 params?: GetApiV1ProfilesProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfilesProfileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const postApiV1ProfilesProfile = (
    createProfileDto: CreateProfileDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/profiles/Profile`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProfileDto, signal
    },
      );
    }



export const getPostApiV1ProfilesProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfile>>, TError,{data: CreateProfileDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfile>>, TError,{data: CreateProfileDto}, TContext> => {

const mutationKey = ['postApiV1ProfilesProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfilesProfile>>, {data: CreateProfileDto}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1ProfilesProfile(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfilesProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfilesProfile>>>
    export type PostApiV1ProfilesProfileMutationBody = CreateProfileDto
    export type PostApiV1ProfilesProfileMutationError = unknown

    export const usePostApiV1ProfilesProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfile>>, TError,{data: CreateProfileDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfilesProfile>>,
        TError,
        {data: CreateProfileDto},
        TContext
      > => {
      return useMutation(getPostApiV1ProfilesProfileMutationOptions(options), queryClient);
    }
    export const getApiV1Profile = (
    params?: GetApiV1ProfileParams,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto[]>(
      {url: `/api/v1/Profile`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1ProfileQueryKey = (params?: GetApiV1ProfileParams,) => {
    return [
    `/api/v1/Profile`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1ProfileQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Profile>>, TError = unknown>(params?: GetApiV1ProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Profile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Profile>>> = ({ signal }) => getApiV1Profile(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Profile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Profile>>>
export type GetApiV1ProfileQueryError = unknown


export function useGetApiV1Profile<TData = Awaited<ReturnType<typeof getApiV1Profile>>, TError = unknown>(
 params: undefined |  GetApiV1ProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Profile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Profile>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Profile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Profile<TData = Awaited<ReturnType<typeof getApiV1Profile>>, TError = unknown>(
 params?: GetApiV1ProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Profile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Profile>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Profile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Profile<TData = Awaited<ReturnType<typeof getApiV1Profile>>, TError = unknown>(
 params?: GetApiV1ProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Profile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Profile<TData = Awaited<ReturnType<typeof getApiV1Profile>>, TError = unknown>(
 params?: GetApiV1ProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Profile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const postApiV1Profile = (
    createProfileDto: CreateProfileDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/Profile`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProfileDto, signal
    },
      );
    }



export const getPostApiV1ProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Profile>>, TError,{data: CreateProfileDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1Profile>>, TError,{data: CreateProfileDto}, TContext> => {

const mutationKey = ['postApiV1Profile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1Profile>>, {data: CreateProfileDto}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1Profile(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1Profile>>>
    export type PostApiV1ProfileMutationBody = CreateProfileDto
    export type PostApiV1ProfileMutationError = unknown

    export const usePostApiV1Profile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Profile>>, TError,{data: CreateProfileDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1Profile>>,
        TError,
        {data: CreateProfileDto},
        TContext
      > => {
      return useMutation(getPostApiV1ProfileMutationOptions(options), queryClient);
    }
    export const getApiV1ProfilesProfileSso = (
    sso: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/profiles/Profile/${sso}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfilesProfileSsoQueryKey = (sso: string,) => {
    return [
    `/api/v1/profiles/Profile/${sso}`
    ] as const;
    }


export const getGetApiV1ProfilesProfileSsoQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError = ProblemDetails>(sso: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfilesProfileSsoQueryKey(sso);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>> = ({ signal }) => getApiV1ProfilesProfileSso(sso, signal);





   return  { queryKey, queryFn, enabled: !!(sso), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfilesProfileSsoQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>>
export type GetApiV1ProfilesProfileSsoQueryError = ProblemDetails


export function useGetApiV1ProfilesProfileSso<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError = ProblemDetails>(
 sso: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileSso<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError = ProblemDetails>(
 sso: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileSso<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError = ProblemDetails>(
 sso: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfilesProfileSso<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError = ProblemDetails>(
 sso: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileSso>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfilesProfileSsoQueryOptions(sso,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getApiV1ProfileSso = (
    sso: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/Profile/${sso}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfileSsoQueryKey = (sso: string,) => {
    return [
    `/api/v1/Profile/${sso}`
    ] as const;
    }


export const getGetApiV1ProfileSsoQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError = ProblemDetails>(sso: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfileSsoQueryKey(sso);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfileSso>>> = ({ signal }) => getApiV1ProfileSso(sso, signal);





   return  { queryKey, queryFn, enabled: !!(sso), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfileSsoQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfileSso>>>
export type GetApiV1ProfileSsoQueryError = ProblemDetails


export function useGetApiV1ProfileSso<TData = Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError = ProblemDetails>(
 sso: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileSso>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileSso>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileSso<TData = Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError = ProblemDetails>(
 sso: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileSso>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileSso>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileSso<TData = Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError = ProblemDetails>(
 sso: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfileSso<TData = Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError = ProblemDetails>(
 sso: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileSso>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfileSsoQueryOptions(sso,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getApiV1ProfilesProfileIdUserDetails = (
    id: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<UserProfileDetailsDto>(
      {url: `/api/v1/profiles/Profile/${id}/userDetails`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfilesProfileIdUserDetailsQueryKey = (id: string,) => {
    return [
    `/api/v1/profiles/Profile/${id}/userDetails`
    ] as const;
    }


export const getGetApiV1ProfilesProfileIdUserDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfilesProfileIdUserDetailsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>> = ({ signal }) => getApiV1ProfilesProfileIdUserDetails(id, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfilesProfileIdUserDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>>
export type GetApiV1ProfilesProfileIdUserDetailsQueryError = ProblemDetails


export function useGetApiV1ProfilesProfileIdUserDetails<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileIdUserDetails<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileIdUserDetails<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfilesProfileIdUserDetails<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdUserDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfilesProfileIdUserDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const postApiV1ProfilesProfileIdUserDetails = (
    id: string,
    userProfileDetailsDto: UserProfileDetailsDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<unknown>(
      {url: `/api/v1/profiles/Profile/${id}/userDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userProfileDetailsDto, signal
    },
      );
    }



export const getPostApiV1ProfilesProfileIdUserDetailsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdUserDetails>>, TError,{id: string;data: UserProfileDetailsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdUserDetails>>, TError,{id: string;data: UserProfileDetailsDto}, TContext> => {

const mutationKey = ['postApiV1ProfilesProfileIdUserDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdUserDetails>>, {id: string;data: UserProfileDetailsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiV1ProfilesProfileIdUserDetails(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfilesProfileIdUserDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdUserDetails>>>
    export type PostApiV1ProfilesProfileIdUserDetailsMutationBody = UserProfileDetailsDto
    export type PostApiV1ProfilesProfileIdUserDetailsMutationError = ProblemDetails

    export const usePostApiV1ProfilesProfileIdUserDetails = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdUserDetails>>, TError,{id: string;data: UserProfileDetailsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfilesProfileIdUserDetails>>,
        TError,
        {id: string;data: UserProfileDetailsDto},
        TContext
      > => {
      return useMutation(getPostApiV1ProfilesProfileIdUserDetailsMutationOptions(options), queryClient);
    }
    export const getApiV1ProfileIdUserDetails = (
    id: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<UserProfileDetailsDto>(
      {url: `/api/v1/Profile/${id}/userDetails`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfileIdUserDetailsQueryKey = (id: string,) => {
    return [
    `/api/v1/Profile/${id}/userDetails`
    ] as const;
    }


export const getGetApiV1ProfileIdUserDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfileIdUserDetailsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>> = ({ signal }) => getApiV1ProfileIdUserDetails(id, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfileIdUserDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>>
export type GetApiV1ProfileIdUserDetailsQueryError = ProblemDetails


export function useGetApiV1ProfileIdUserDetails<TData = Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileIdUserDetails<TData = Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileIdUserDetails<TData = Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfileIdUserDetails<TData = Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdUserDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfileIdUserDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const postApiV1ProfileIdUserDetails = (
    id: string,
    userProfileDetailsDto: UserProfileDetailsDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<unknown>(
      {url: `/api/v1/Profile/${id}/userDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userProfileDetailsDto, signal
    },
      );
    }



export const getPostApiV1ProfileIdUserDetailsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdUserDetails>>, TError,{id: string;data: UserProfileDetailsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdUserDetails>>, TError,{id: string;data: UserProfileDetailsDto}, TContext> => {

const mutationKey = ['postApiV1ProfileIdUserDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfileIdUserDetails>>, {id: string;data: UserProfileDetailsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiV1ProfileIdUserDetails(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfileIdUserDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfileIdUserDetails>>>
    export type PostApiV1ProfileIdUserDetailsMutationBody = UserProfileDetailsDto
    export type PostApiV1ProfileIdUserDetailsMutationError = ProblemDetails

    export const usePostApiV1ProfileIdUserDetails = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdUserDetails>>, TError,{id: string;data: UserProfileDetailsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfileIdUserDetails>>,
        TError,
        {id: string;data: UserProfileDetailsDto},
        TContext
      > => {
      return useMutation(getPostApiV1ProfileIdUserDetailsMutationOptions(options), queryClient);
    }
    export const getApiV1ProfilesProfileIdPermissions = (
    id: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfilePermissionsDto>(
      {url: `/api/v1/profiles/Profile/${id}/permissions`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfilesProfileIdPermissionsQueryKey = (id: string,) => {
    return [
    `/api/v1/profiles/Profile/${id}/permissions`
    ] as const;
    }


export const getGetApiV1ProfilesProfileIdPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfilesProfileIdPermissionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>> = ({ signal }) => getApiV1ProfilesProfileIdPermissions(id, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfilesProfileIdPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>>
export type GetApiV1ProfilesProfileIdPermissionsQueryError = ProblemDetails


export function useGetApiV1ProfilesProfileIdPermissions<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileIdPermissions<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileIdPermissions<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfilesProfileIdPermissions<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfilesProfileIdPermissionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const postApiV1ProfilesProfileIdPermissions = (
    id: string,
    profilePermissionsDto: ProfilePermissionsDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<unknown>(
      {url: `/api/v1/profiles/Profile/${id}/permissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: profilePermissionsDto, signal
    },
      );
    }



export const getPostApiV1ProfilesProfileIdPermissionsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdPermissions>>, TError,{id: string;data: ProfilePermissionsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdPermissions>>, TError,{id: string;data: ProfilePermissionsDto}, TContext> => {

const mutationKey = ['postApiV1ProfilesProfileIdPermissions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdPermissions>>, {id: string;data: ProfilePermissionsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiV1ProfilesProfileIdPermissions(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfilesProfileIdPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdPermissions>>>
    export type PostApiV1ProfilesProfileIdPermissionsMutationBody = ProfilePermissionsDto
    export type PostApiV1ProfilesProfileIdPermissionsMutationError = ProblemDetails

    export const usePostApiV1ProfilesProfileIdPermissions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdPermissions>>, TError,{id: string;data: ProfilePermissionsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfilesProfileIdPermissions>>,
        TError,
        {id: string;data: ProfilePermissionsDto},
        TContext
      > => {
      return useMutation(getPostApiV1ProfilesProfileIdPermissionsMutationOptions(options), queryClient);
    }
    export const getApiV1ProfileIdPermissions = (
    id: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfilePermissionsDto>(
      {url: `/api/v1/Profile/${id}/permissions`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfileIdPermissionsQueryKey = (id: string,) => {
    return [
    `/api/v1/Profile/${id}/permissions`
    ] as const;
    }


export const getGetApiV1ProfileIdPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfileIdPermissionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>> = ({ signal }) => getApiV1ProfileIdPermissions(id, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfileIdPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>>
export type GetApiV1ProfileIdPermissionsQueryError = ProblemDetails


export function useGetApiV1ProfileIdPermissions<TData = Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileIdPermissions<TData = Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileIdPermissions<TData = Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfileIdPermissions<TData = Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfileIdPermissionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const postApiV1ProfileIdPermissions = (
    id: string,
    profilePermissionsDto: ProfilePermissionsDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<unknown>(
      {url: `/api/v1/Profile/${id}/permissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: profilePermissionsDto, signal
    },
      );
    }



export const getPostApiV1ProfileIdPermissionsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdPermissions>>, TError,{id: string;data: ProfilePermissionsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdPermissions>>, TError,{id: string;data: ProfilePermissionsDto}, TContext> => {

const mutationKey = ['postApiV1ProfileIdPermissions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfileIdPermissions>>, {id: string;data: ProfilePermissionsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiV1ProfileIdPermissions(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfileIdPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfileIdPermissions>>>
    export type PostApiV1ProfileIdPermissionsMutationBody = ProfilePermissionsDto
    export type PostApiV1ProfileIdPermissionsMutationError = ProblemDetails

    export const usePostApiV1ProfileIdPermissions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdPermissions>>, TError,{id: string;data: ProfilePermissionsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfileIdPermissions>>,
        TError,
        {id: string;data: ProfilePermissionsDto},
        TContext
      > => {
      return useMutation(getPostApiV1ProfileIdPermissionsMutationOptions(options), queryClient);
    }
    export const postApiV1ProfilesProfileIdMailSettings = (
    id: string,
    mailSettingsDto: MailSettingsDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/profiles/Profile/${id}/mailSettings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mailSettingsDto, signal
    },
      );
    }



export const getPostApiV1ProfilesProfileIdMailSettingsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdMailSettings>>, TError,{id: string;data: MailSettingsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdMailSettings>>, TError,{id: string;data: MailSettingsDto}, TContext> => {

const mutationKey = ['postApiV1ProfilesProfileIdMailSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdMailSettings>>, {id: string;data: MailSettingsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiV1ProfilesProfileIdMailSettings(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfilesProfileIdMailSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdMailSettings>>>
    export type PostApiV1ProfilesProfileIdMailSettingsMutationBody = MailSettingsDto
    export type PostApiV1ProfilesProfileIdMailSettingsMutationError = ProblemDetails

    export const usePostApiV1ProfilesProfileIdMailSettings = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileIdMailSettings>>, TError,{id: string;data: MailSettingsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfilesProfileIdMailSettings>>,
        TError,
        {id: string;data: MailSettingsDto},
        TContext
      > => {
      return useMutation(getPostApiV1ProfilesProfileIdMailSettingsMutationOptions(options), queryClient);
    }
    export const postApiV1ProfileIdMailSettings = (
    id: string,
    mailSettingsDto: MailSettingsDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/Profile/${id}/mailSettings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mailSettingsDto, signal
    },
      );
    }



export const getPostApiV1ProfileIdMailSettingsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdMailSettings>>, TError,{id: string;data: MailSettingsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdMailSettings>>, TError,{id: string;data: MailSettingsDto}, TContext> => {

const mutationKey = ['postApiV1ProfileIdMailSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfileIdMailSettings>>, {id: string;data: MailSettingsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiV1ProfileIdMailSettings(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfileIdMailSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfileIdMailSettings>>>
    export type PostApiV1ProfileIdMailSettingsMutationBody = MailSettingsDto
    export type PostApiV1ProfileIdMailSettingsMutationError = ProblemDetails

    export const usePostApiV1ProfileIdMailSettings = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileIdMailSettings>>, TError,{id: string;data: MailSettingsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfileIdMailSettings>>,
        TError,
        {id: string;data: MailSettingsDto},
        TContext
      > => {
      return useMutation(getPostApiV1ProfileIdMailSettingsMutationOptions(options), queryClient);
    }
    export const postApiV1ProfilesProfileUserIdReception = (
    userId: string,
    postApiV1ProfilesProfileUserIdReceptionBody: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/profiles/Profile/${userId}/reception`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV1ProfilesProfileUserIdReceptionBody, signal
    },
      );
    }



export const getPostApiV1ProfilesProfileUserIdReceptionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileUserIdReception>>, TError,{userId: string;data: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileUserIdReception>>, TError,{userId: string;data: string}, TContext> => {

const mutationKey = ['postApiV1ProfilesProfileUserIdReception'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfilesProfileUserIdReception>>, {userId: string;data: string}> = (props) => {
          const {userId,data} = props ?? {};

          return  postApiV1ProfilesProfileUserIdReception(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfilesProfileUserIdReceptionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfilesProfileUserIdReception>>>
    export type PostApiV1ProfilesProfileUserIdReceptionMutationBody = string
    export type PostApiV1ProfilesProfileUserIdReceptionMutationError = ProblemDetails

    export const usePostApiV1ProfilesProfileUserIdReception = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileUserIdReception>>, TError,{userId: string;data: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfilesProfileUserIdReception>>,
        TError,
        {userId: string;data: string},
        TContext
      > => {
      return useMutation(getPostApiV1ProfilesProfileUserIdReceptionMutationOptions(options), queryClient);
    }
    export const getApiV1ProfilesProfileUserIdReception = (
    userId: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ReceptionDto>(
      {url: `/api/v1/profiles/Profile/${userId}/reception`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfilesProfileUserIdReceptionQueryKey = (userId: string,) => {
    return [
    `/api/v1/profiles/Profile/${userId}/reception`
    ] as const;
    }


export const getGetApiV1ProfilesProfileUserIdReceptionQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError = ProblemDetails>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfilesProfileUserIdReceptionQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>> = ({ signal }) => getApiV1ProfilesProfileUserIdReception(userId, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfilesProfileUserIdReceptionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>>
export type GetApiV1ProfilesProfileUserIdReceptionQueryError = ProblemDetails


export function useGetApiV1ProfilesProfileUserIdReception<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError = ProblemDetails>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileUserIdReception<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileUserIdReception<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfilesProfileUserIdReception<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileUserIdReception>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfilesProfileUserIdReceptionQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const postApiV1ProfileUserIdReception = (
    userId: string,
    postApiV1ProfileUserIdReceptionBody: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/Profile/${userId}/reception`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV1ProfileUserIdReceptionBody, signal
    },
      );
    }



export const getPostApiV1ProfileUserIdReceptionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileUserIdReception>>, TError,{userId: string;data: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileUserIdReception>>, TError,{userId: string;data: string}, TContext> => {

const mutationKey = ['postApiV1ProfileUserIdReception'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfileUserIdReception>>, {userId: string;data: string}> = (props) => {
          const {userId,data} = props ?? {};

          return  postApiV1ProfileUserIdReception(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfileUserIdReceptionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfileUserIdReception>>>
    export type PostApiV1ProfileUserIdReceptionMutationBody = string
    export type PostApiV1ProfileUserIdReceptionMutationError = ProblemDetails

    export const usePostApiV1ProfileUserIdReception = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileUserIdReception>>, TError,{userId: string;data: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfileUserIdReception>>,
        TError,
        {userId: string;data: string},
        TContext
      > => {
      return useMutation(getPostApiV1ProfileUserIdReceptionMutationOptions(options), queryClient);
    }
    export const getApiV1ProfileUserIdReception = (
    userId: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ReceptionDto>(
      {url: `/api/v1/Profile/${userId}/reception`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfileUserIdReceptionQueryKey = (userId: string,) => {
    return [
    `/api/v1/Profile/${userId}/reception`
    ] as const;
    }


export const getGetApiV1ProfileUserIdReceptionQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError = ProblemDetails>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfileUserIdReceptionQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>> = ({ signal }) => getApiV1ProfileUserIdReception(userId, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfileUserIdReceptionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>>
export type GetApiV1ProfileUserIdReceptionQueryError = ProblemDetails


export function useGetApiV1ProfileUserIdReception<TData = Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError = ProblemDetails>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileUserIdReception<TData = Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileUserIdReception<TData = Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfileUserIdReception<TData = Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError = ProblemDetails>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileUserIdReception>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfileUserIdReceptionQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const postApiV1ProfilesProfileId = (
    id: string,
    profile: Profile,
    params?: PostApiV1ProfilesProfileIdParams,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/profiles/Profile/${id}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: profile,
        params, signal
    },
      );
    }



export const getPostApiV1ProfilesProfileIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileId>>, TError,{id: string;data: Profile;params?: PostApiV1ProfilesProfileIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileId>>, TError,{id: string;data: Profile;params?: PostApiV1ProfilesProfileIdParams}, TContext> => {

const mutationKey = ['postApiV1ProfilesProfileId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfilesProfileId>>, {id: string;data: Profile;params?: PostApiV1ProfilesProfileIdParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  postApiV1ProfilesProfileId(id,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfilesProfileIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfilesProfileId>>>
    export type PostApiV1ProfilesProfileIdMutationBody = Profile
    export type PostApiV1ProfilesProfileIdMutationError = unknown

    export const usePostApiV1ProfilesProfileId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfilesProfileId>>, TError,{id: string;data: Profile;params?: PostApiV1ProfilesProfileIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfilesProfileId>>,
        TError,
        {id: string;data: Profile;params?: PostApiV1ProfilesProfileIdParams},
        TContext
      > => {
      return useMutation(getPostApiV1ProfilesProfileIdMutationOptions(options), queryClient);
    }
    export const postApiV1ProfileId = (
    id: string,
    profile: Profile,
    params?: PostApiV1ProfileIdParams,
 signal?: AbortSignal
) => {


      return visitorApiInstance<ProfileDto>(
      {url: `/api/v1/Profile/${id}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: profile,
        params, signal
    },
      );
    }



export const getPostApiV1ProfileIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileId>>, TError,{id: string;data: Profile;params?: PostApiV1ProfileIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileId>>, TError,{id: string;data: Profile;params?: PostApiV1ProfileIdParams}, TContext> => {

const mutationKey = ['postApiV1ProfileId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ProfileId>>, {id: string;data: Profile;params?: PostApiV1ProfileIdParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  postApiV1ProfileId(id,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ProfileIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ProfileId>>>
    export type PostApiV1ProfileIdMutationBody = Profile
    export type PostApiV1ProfileIdMutationError = unknown

    export const usePostApiV1ProfileId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ProfileId>>, TError,{id: string;data: Profile;params?: PostApiV1ProfileIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ProfileId>>,
        TError,
        {id: string;data: Profile;params?: PostApiV1ProfileIdParams},
        TContext
      > => {
      return useMutation(getPostApiV1ProfileIdMutationOptions(options), queryClient);
    }
    export const patchApiV1ProfilesProfileIdTenant = (
    id: string,
    setTenantRequest: SetTenantRequest,
 signal?: AbortSignal
) => {


      return visitorApiInstance<unknown>(
      {url: `/api/v1/profiles/Profile/${id}/tenant`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setTenantRequest, signal
    },
      );
    }



export const getPatchApiV1ProfilesProfileIdTenantMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdTenant>>, TError,{id: string;data: SetTenantRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdTenant>>, TError,{id: string;data: SetTenantRequest}, TContext> => {

const mutationKey = ['patchApiV1ProfilesProfileIdTenant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdTenant>>, {id: string;data: SetTenantRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiV1ProfilesProfileIdTenant(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1ProfilesProfileIdTenantMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdTenant>>>
    export type PatchApiV1ProfilesProfileIdTenantMutationBody = SetTenantRequest
    export type PatchApiV1ProfilesProfileIdTenantMutationError = ProblemDetails

    export const usePatchApiV1ProfilesProfileIdTenant = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdTenant>>, TError,{id: string;data: SetTenantRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdTenant>>,
        TError,
        {id: string;data: SetTenantRequest},
        TContext
      > => {
      return useMutation(getPatchApiV1ProfilesProfileIdTenantMutationOptions(options), queryClient);
    }
    export const patchApiV1ProfileIdTenant = (
    id: string,
    setTenantRequest: SetTenantRequest,
 signal?: AbortSignal
) => {


      return visitorApiInstance<unknown>(
      {url: `/api/v1/Profile/${id}/tenant`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setTenantRequest, signal
    },
      );
    }



export const getPatchApiV1ProfileIdTenantMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfileIdTenant>>, TError,{id: string;data: SetTenantRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfileIdTenant>>, TError,{id: string;data: SetTenantRequest}, TContext> => {

const mutationKey = ['patchApiV1ProfileIdTenant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1ProfileIdTenant>>, {id: string;data: SetTenantRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiV1ProfileIdTenant(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1ProfileIdTenantMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ProfileIdTenant>>>
    export type PatchApiV1ProfileIdTenantMutationBody = SetTenantRequest
    export type PatchApiV1ProfileIdTenantMutationError = ProblemDetails

    export const usePatchApiV1ProfileIdTenant = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfileIdTenant>>, TError,{id: string;data: SetTenantRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1ProfileIdTenant>>,
        TError,
        {id: string;data: SetTenantRequest},
        TContext
      > => {
      return useMutation(getPatchApiV1ProfileIdTenantMutationOptions(options), queryClient);
    }
    export const patchApiV1ProfilesProfileIdDefaultLocation = (
    id: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<unknown>(
      {url: `/api/v1/profiles/Profile/${id}/default-location`, method: 'PATCH', signal
    },
      );
    }



export const getPatchApiV1ProfilesProfileIdDefaultLocationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdDefaultLocation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdDefaultLocation>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchApiV1ProfilesProfileIdDefaultLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdDefaultLocation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchApiV1ProfilesProfileIdDefaultLocation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1ProfilesProfileIdDefaultLocationMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdDefaultLocation>>>

    export type PatchApiV1ProfilesProfileIdDefaultLocationMutationError = ProblemDetails

    export const usePatchApiV1ProfilesProfileIdDefaultLocation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdDefaultLocation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1ProfilesProfileIdDefaultLocation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPatchApiV1ProfilesProfileIdDefaultLocationMutationOptions(options), queryClient);
    }
    export const patchApiV1ProfileIdDefaultLocation = (
    id: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<unknown>(
      {url: `/api/v1/Profile/${id}/default-location`, method: 'PATCH', signal
    },
      );
    }



export const getPatchApiV1ProfileIdDefaultLocationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfileIdDefaultLocation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfileIdDefaultLocation>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchApiV1ProfileIdDefaultLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1ProfileIdDefaultLocation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchApiV1ProfileIdDefaultLocation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1ProfileIdDefaultLocationMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ProfileIdDefaultLocation>>>

    export type PatchApiV1ProfileIdDefaultLocationMutationError = ProblemDetails

    export const usePatchApiV1ProfileIdDefaultLocation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ProfileIdDefaultLocation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1ProfileIdDefaultLocation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPatchApiV1ProfileIdDefaultLocationMutationOptions(options), queryClient);
    }
    export const getApiV1ProfilesProfileIdAssignableAccess = (
    id: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<AssignableAccessDto>(
      {url: `/api/v1/profiles/Profile/${id}/assignable-access`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfilesProfileIdAssignableAccessQueryKey = (id: string,) => {
    return [
    `/api/v1/profiles/Profile/${id}/assignable-access`
    ] as const;
    }


export const getGetApiV1ProfilesProfileIdAssignableAccessQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfilesProfileIdAssignableAccessQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>> = ({ signal }) => getApiV1ProfilesProfileIdAssignableAccess(id, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfilesProfileIdAssignableAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>>
export type GetApiV1ProfilesProfileIdAssignableAccessQueryError = ProblemDetails


export function useGetApiV1ProfilesProfileIdAssignableAccess<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileIdAssignableAccess<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfilesProfileIdAssignableAccess<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfilesProfileIdAssignableAccess<TData = Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfilesProfileIdAssignableAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfilesProfileIdAssignableAccessQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const putApiV1ProfilesProfileIdAssignableAccess = (
    id: string,
    assignableAccessDto: AssignableAccessDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<AssignableAccessDto>(
      {url: `/api/v1/profiles/Profile/${id}/assignable-access`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: assignableAccessDto, signal
    },
      );
    }



export const getPutApiV1ProfilesProfileIdAssignableAccessMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1ProfilesProfileIdAssignableAccess>>, TError,{id: string;data: AssignableAccessDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1ProfilesProfileIdAssignableAccess>>, TError,{id: string;data: AssignableAccessDto}, TContext> => {

const mutationKey = ['putApiV1ProfilesProfileIdAssignableAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1ProfilesProfileIdAssignableAccess>>, {id: string;data: AssignableAccessDto}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiV1ProfilesProfileIdAssignableAccess(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1ProfilesProfileIdAssignableAccessMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ProfilesProfileIdAssignableAccess>>>
    export type PutApiV1ProfilesProfileIdAssignableAccessMutationBody = AssignableAccessDto
    export type PutApiV1ProfilesProfileIdAssignableAccessMutationError = ProblemDetails

    export const usePutApiV1ProfilesProfileIdAssignableAccess = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1ProfilesProfileIdAssignableAccess>>, TError,{id: string;data: AssignableAccessDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1ProfilesProfileIdAssignableAccess>>,
        TError,
        {id: string;data: AssignableAccessDto},
        TContext
      > => {
      return useMutation(getPutApiV1ProfilesProfileIdAssignableAccessMutationOptions(options), queryClient);
    }
    export const getApiV1ProfileIdAssignableAccess = (
    id: string,
 signal?: AbortSignal
) => {


      return visitorApiInstance<AssignableAccessDto>(
      {url: `/api/v1/Profile/${id}/assignable-access`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ProfileIdAssignableAccessQueryKey = (id: string,) => {
    return [
    `/api/v1/Profile/${id}/assignable-access`
    ] as const;
    }


export const getGetApiV1ProfileIdAssignableAccessQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ProfileIdAssignableAccessQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>> = ({ signal }) => getApiV1ProfileIdAssignableAccess(id, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ProfileIdAssignableAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>>
export type GetApiV1ProfileIdAssignableAccessQueryError = ProblemDetails


export function useGetApiV1ProfileIdAssignableAccess<TData = Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileIdAssignableAccess<TData = Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ProfileIdAssignableAccess<TData = Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ProfileIdAssignableAccess<TData = Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ProfileIdAssignableAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ProfileIdAssignableAccessQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const putApiV1ProfileIdAssignableAccess = (
    id: string,
    assignableAccessDto: AssignableAccessDto,
 signal?: AbortSignal
) => {


      return visitorApiInstance<AssignableAccessDto>(
      {url: `/api/v1/Profile/${id}/assignable-access`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: assignableAccessDto, signal
    },
      );
    }



export const getPutApiV1ProfileIdAssignableAccessMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1ProfileIdAssignableAccess>>, TError,{id: string;data: AssignableAccessDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1ProfileIdAssignableAccess>>, TError,{id: string;data: AssignableAccessDto}, TContext> => {

const mutationKey = ['putApiV1ProfileIdAssignableAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1ProfileIdAssignableAccess>>, {id: string;data: AssignableAccessDto}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiV1ProfileIdAssignableAccess(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1ProfileIdAssignableAccessMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ProfileIdAssignableAccess>>>
    export type PutApiV1ProfileIdAssignableAccessMutationBody = AssignableAccessDto
    export type PutApiV1ProfileIdAssignableAccessMutationError = ProblemDetails

    export const usePutApiV1ProfileIdAssignableAccess = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1ProfileIdAssignableAccess>>, TError,{id: string;data: AssignableAccessDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1ProfileIdAssignableAccess>>,
        TError,
        {id: string;data: AssignableAccessDto},
        TContext
      > => {
      return useMutation(getPutApiV1ProfileIdAssignableAccessMutationOptions(options), queryClient);
    }
